import {FETCHED_HISTORY,} from '../../types';
import {deletePending} from '../../ui/marketplace';
import callBC from '../../helpers/bc.js';
import {getBlake} from '../../passport/get';

export function getNRGTransfers(done){
  return async function(dispatch,getState){
    let addr = getState().passport.wallet.emb.address;
    let data = await callBC(getState().settings.settings,'getTransfers',[addr])
    let blake_address = getState().passport.blake ? getState().passport.blake : await getBlake(dispatch,getState());
    if(data && data.result && data.result.transfersList){
      let history = data.result.transfersList.map((h)=>{
        if(h.from == blake_address) h.from = addr.toLowerCase()
        h.color = h.to == addr.toLowerCase() ? `rgb(101, 173, 97)` : `rgb(222, 114, 114)`;
        if(h.from == h.to) h.color = 'grey';

        h.type = "NRG";
        h.value = h.amount
        if(h.from == 'coinbase') h.from = 'Mined';
        return h;
      }).reverse()

      deletePending(history,getState(),dispatch)

      dispatch({
        type: FETCHED_HISTORY,
        payload:{history,type:'nrg'}
      })
    }
  }
}
